import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import { City } from 'src/app/_models/city.model';
import { CityService } from 'src/app/_services/city.service';

@Component({
  selector: 'app-add-city',
  templateUrl: './add-city.component.html',
  styleUrls: ['./add-city.component.scss'],
})
export class AddCityComponent implements OnInit {
  pageTitle: string = 'Cities';
  editMode = false;
  city: City = { name: '', enName: '', isActive: true, countryId: 1 };

  addCityForm: FormGroup;
  isSubmited: boolean = false;

  constructor(
    private cityService: CityService,
    private activatedRoute: ActivatedRoute,
    public toastr: ToastrService,
    private router: Router,
    private _formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.addCityForm = this._formBuilder.group({
      enCityName: [null, [Validators.required, Validators.pattern(/^[A-Za-z][A-Za-z0-9 .-]*$/)]],
      arCityName: [null, [Validators.required, Validators.pattern(/^[\u0621-\u064A0-9 .]+$/)]],
      cityActiveCheck: [true, [Validators.required]],
    });

    const countryId = this.activatedRoute.snapshot.params.countryId;
    if (countryId) {
      this.city.countryId = countryId;
    }
    this.editMode =
      (this.activatedRoute.snapshot.url[2] &&
        this.activatedRoute.snapshot.url[2].path === 'edit' &&
        true) ||
      (this.activatedRoute.snapshot.url[1] &&
        this.activatedRoute.snapshot.url[1].path === 'edit' &&
        true);
    //

    if (this.editMode) {
      const id = this.activatedRoute.snapshot.params.cityId;

      this.cityService.getCityById(id).subscribe((res) => {
        this.city = res.data;



        this.addCityForm.controls['enCityName'].setValue(this.city.enName);
        this.addCityForm.controls['arCityName'].setValue(this.city.name);
        this.addCityForm.controls['cityActiveCheck'].setValue(this.city.isActive);


      });
    }
  }

  onAddCitySubmit() {
    this.isSubmited = true;

    this.city.enName = this.addCityForm.value.enCityName;
    this.city.name = this.addCityForm.value.arCityName;
    this.city.isActive = this.addCityForm.value.cityActiveCheck;

    if (this.addCityForm.valid) {
      if (this.editMode) {
        this.cityService.updateCity(this.city).subscribe((res) => {
          showNotification(
            'success',
            `${res.data.enName} has been updated`,
            this.toastr
          );
          this.router.navigateByUrl('geo/cities');
        });
      } else {
        this.cityService.addCity(this.city).subscribe((res) => {
          showNotification(
            'success',
            `${res.data.enName} has been added`,
            this.toastr
          );
          this.router.navigateByUrl('geo/cities');
        });
      }
    } else {
      showNotification(
        'danger',
        'You should fill the form fields with the correct data!',
        this.toastr
      );
    }
  }
}
